import { Badge } from "reactstrap";
import classnames from "classnames";
import { getInitials } from "@helpers/utils";

const Avatar = (props) => {
    
    // ** Props
    const {
        img,
        size,
        icon,
        color,
        status,
        badgeUp,
        content,
        tag: Tag = "div",
        initials,
        className,
        badgeText,
        badgeColor,
        imgClassName,
        contentStyles,
        light = true,
        rounded = false,
        disabled,
        alt,
        ...rest
    } = props;
    const tempSize = icon?.type ? "md" : size;
    return (
        <Tag
            className={classnames("avatar", {
                [className]           : className,
                [`bg-light-${color}`] : color && light,
                [`bg-${color}`]       : color && !light,
                [`avatar-${tempSize}`]: tempSize,
                rounded
            })}
            disabled={disabled}
            {...rest}>
            {img === false || img === undefined || img === null  ? (
                <span
                    className={classnames("avatar-content", {
                        "position-relative": badgeUp,
                        "cursor-pointer"   : !disabled
                    })}
                    style={contentStyles}>
                    {initials ? getInitials(content) : content}

                    {icon  ? icon.type ? icon : <i className={`mdi mdi-${icon}`}/> : null}
                    {badgeUp ? (
                        <Badge color={badgeColor || "primary"} className='badge-sm badge-up' pill>
                            {badgeText || "0"}
                        </Badge>
                    ) : null}
                </span>
            ) : (
                <img
                    className={classnames("avatar-", {
                        [imgClassName]  : imgClassName,
                        "cursor-pointer": !disabled
                    })}
                    src={img}
                    id="avatar-img"
                    alt={alt}
                    // referrerPolicy="no-referrer"
                    height={32}
                    width={32}/>
            )}
            {status ? (
                <span
                    className={classnames({
                        [`avatar-status-${status}`]: status,
                        [`avatar-status-${size}`]  : size
                    })}></span>
            ) : null}
        </Tag>
    );
};

export default Avatar;
